<template>
  <div class="regional_questionaire" :class="{ 'as-slider': asSlider }">
    <h1 class="regional_questionaire__heading">
      Datacenter
      <span class="ml-1 text-red">Regionalumfrage 2019</span>
    </h1>

    <div class="flex items-center p-2 font-headline">
      <div class="text-sm">Region wählen</div>
      <select
        v-model="selectedRegion"
        class="ml-2 border-half border-black-800"
      >
        <option v-for="(region, index) in regions" :key="index">
          {{ region }}
        </option>
      </select>
    </div>
    <div class="relative">
      <div v-if="$apollo.loading" class="regional_questionaire__loader">
        <Spinner />
      </div>

      <div
        v-if="!asSlider"
        class="hidden flex-wrap items-stretch justify-center md:flex"
      >
        <RegionalQuestionaireQuestion
          v-for="(question, index) in questions"
          :key="index"
          :question="question"
        />
      </div>

      <div :class="{ 'md:hidden': !asSlider }">
        <Swiper with-pagination="bullets">
          <SwiperSlide v-for="(question, index) in questions" :key="index">
            <RegionalQuestionaireQuestion :question="question" class="h-48" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import RegionalQuestionaireQuestion from '~components/content/widgets/listings/RegionalQuestionaireQuestion.vue'
import Swiper from '~components/utils/Swiper.vue'
import SwiperSlide from '~components/utils/SwiperSlide.vue'

export default {
  components: {
    RegionalQuestionaireQuestion,
    Swiper,
    SwiperSlide,
  },
  props: {
    asSlider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questions: [],
      regions: [],
      selectedRegion: 'Bregenz',
    }
  },
  watch: {
    questions(newVal) {
      if (newVal.length > 0) {
        // this.mountEvents()
      }
    },
  },
  methods: {
    getPieTotals(question) {
      return question.a1 + question.a2 + question.a3
    },
  },
  apollo: {
    regionalquestionaire: {
      query: require('~base/graphql/queries/RegionalQuestionaire.gql'),
      variables() {
        return {
          region: this.selectedRegion,
        }
      },
      prefetch() {
        return {
          region: this.selectedRegion,
        }
      },
      result({ data }) {
        if (!data) return
        if (data.regionalquestionaire && data.regionalquestionaireRegions) {
          this.regions = data.regionalquestionaireRegions.region
          this.questions = data.regionalquestionaire.data
        }
      },
      fetchPolicy: 'network-first',
    },
  },
}
</script>

<style>
@import '~components/content/widgets/listings/RegionalQuestionaire.css';
</style>
